import React, { Fragment } from "react";
import { List, Datagrid, TextField , CardActions , CreateButton,ReferenceField} from 'react-admin';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';

import {Route} from 'react-router';
import CsCreate from './CsCreate';
import CsEdit from './CsEdit';
import {Drawer} from '@material-ui/core' ;

const CsListActions =({basePath}) => (
    <CardActions>
        <CreateButton basePath={basePath} />
    </CardActions>
)
class CsList extends React.Component {
    render () {
        const props = this.props;
        return (
            <Fragment>
                <List {...props} actions={<CsListActions />} perPage={25}>
                <Datagrid rowClick="edit">
                    <TextField source="id" label="id" />
                    <TextField source="date" label="date" />
                    <ReferenceField link={false} source="customerId" label="고객사"  reference="customers" >
                        <TextField source="name"/>
                    </ReferenceField>
                    <ReferenceField link={false} source="csCategoryId" label="분류"  reference="commonCodes" >
                        <TextField source="desc"  />
                    </ReferenceField>
                    <TextField source="desc" label="내용" />

                </Datagrid>
                </List>
                <Route path="/cs/create">
                {({ match }) => (
                    <Drawer open={!!match} anchor="right" onClose={this.handleClose}>
                    <CsCreate onCancel={this.handleClose} {...props} />
                    </Drawer>
                )}
                </Route>
                <Route path="/cs/:id">
                {({ match }) => {
                    const isMatch = match && match.params && match.params.id !== "create";

                    return (
                    <Drawer open={isMatch} anchor="right" onClose={this.handleClose}>
                        {/* To avoid any errors if the route does not match, we don't render at all the component in this case */}
                        {isMatch ? (
                        <CsEdit
                            id={match.params.id}
                            onCancel={this.handleClose}
                            {...props}
                        />
                        ) : null}
                    </Drawer>
                    );
                }}
                </Route>
                {/* <Route path='/menus/create' render = {() => (
                    <Drawer open anchor='right' onClose={this.handleClose}>
                        <MenuCreate  onCancel={this.handleClose} {...props} />
                    </Drawer>
                )} /> */}
            </Fragment>
        );
    }

handleClose = () => {
    this.props.push("/cs");
};
}

export default connect (
    undefined,
    {push}
) (CsList) ;

/* export const MenuList = (props) => (
    <React.Fragment>
    <List {...props} actions={<MenuListActions />}>
                <Datagrid rowClick="edit">
                    <TextField source="id" label="id" />
                    <TextField source="supplierId" label="*공급자" />
                    <TextField source="serviceTypeId" label="*오더가능시간"/>
                    <TextField source="ratingFooding" label="별점"/>
                    <TextField source="name" label="메인"/>
                    <TextField source="menuDesc" label="*서브"/>
                    <TextField source="packageCount" label="용기수"/>
                    <TextField source="price" label="단가"/>
                    <TextField source="orderQtyMin" label="최소수량"/>
                    <TextField source="orderQtyMax" label="최대수량"/>
                    <TextField source="categoryLv1Id" label="카테고리"/>
                    <TextField source="serviceTypeId" label="취식형태"/>
                    <TextField source="curationGenderId" label="태그1"/>
                    <TextField source="curation" label="테그2"/>
                    <TextField source="curation" label="큐레이션"/>
                </Datagrid>
                </List>
                <Route path='/menus/create' render = {() => (
                    <Drawer open anchor='right' onClose={this.handleClose}>
                        <MenuCreate {...props} />
                    </Drawer>
                )} />
    </React.Fragment>
);
export default MenuList; */